import React ,{Component} from 'react';
import IconButton from '@mui/material/IconButton';

import Grid from '@mui/material/Grid';

import { makeStyles } from '@mui/styles';
 
import InputLabel from '@mui/material/InputLabel';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';

import FormControl from '@mui/material/FormControl';

import {  NavLink,Navigate  } from 'react-router-dom';
import axios from 'axios';
import Serverurl from './Apiurl';
import Collapse from '@mui/material/Collapse';
import CloseIcon from '@mui/icons-material/Close';
import Alert from '@mui/material/Alert';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Select from '@mui/material/Select';

const useStyles = makeStyles(theme => ({
 
  root: {
    width: 500,
    '& > * + *': {
      marginTop: theme.spacing(2),
    },
  },

container: {  
    maxHeight: 440,  
  }, 

  table: {
    minWidth: 750,
  },
  
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
	 minWidth: 120,
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
  
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  
   textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: 200,
  },
}));




 

export default class Addcustomer extends Component {

  
  
  
  
  constructor(props) {
    super(props);
	
	 this.state = {cuid:'',cuidarray:[],open:false,data:[],redirect: false,details:'',btndisabled:false,submitbtn:"Submit",
	 	 logredirect:false,pagename:'',names:"",emailid:"",phoneno:"",passwords:"",hidepawd:"",
submitbtn:"Submit"  
      }
   
}


myChangeHandler = (event) => {
 
  const re = /^[0-9]+$/;
  let nam = event.target.name;
  let val = event.target.value;
  if(nam==="phoneno")
  {
	  if (event.target.value === '' || re.test(event.target.value)) {
	  this.setState({[nam]: val}); 
  }
  }
  else{
	  
	   this.setState({[nam]: val});
  }
 
  
}

 getParameterByName(name, url) {
    if (!url) url = window.location.href;
    url = url.toLowerCase(); 
    name = name.replace(/[\[\]]/g, "\\$&").toLowerCase();
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
}


handleErrorclose=(event)=>{
	  
	this.setState({open: false});  
  }



componentDidMount() {
	document.title = "AthaYog Living - Customer Management"; 

if(localStorage.getItem("AYLuserid")==null)
		 {

		   this.setState({
            logredirect: true,
			pagename:'/Default'
          })
		  }
		  
		   let search = window.location.href;
	 let Custid = this.getParameterByName('cuid',search);
	if(Custid!==null)
 {
	 axios.get(Serverurl+'ajaxcustomer.php?action=getall&cu_id='+Custid)
  .then(resp => {  
		
    if(resp.data.length>0){
			this.setState({  
		names:resp.data[0].cu_name,
		emailid:resp.data[0].cu_emailid,
		phoneno:resp.data[0].cu_phoneno,
        	cuid:resp.data[0].cu_id,
			 	  
		hidepawd:	resp.data[0].cu_password,  
			});
	}

  });
 		
 }	

}





  handleSubmit= (event) => {
		const remail= /\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/;

    event.preventDefault();
	
	  	let names=this.state.names;
    let emailid = this.state.emailid;
	let passwords = this.state.passwords;
    let phoneno = this.state.phoneno;
let hidepawd = this.state.hidepawd;



if(names==="")
{
	this.setState({errormessage:"Please Enter Name",erropen:true});
	return false;
}

 if(emailid!=="")
{
	

	
	 if (!remail.test(emailid)) {
	 this.setState({errormessage:"Please Enter Valid Email Id",erropen:true});
		 window.scrollTo({        top: 0     })
	return false; 
  }
}
if(phoneno==="")
{
	this.setState({errormessage:"Please Enter Phoneno.",erropen:true});
	return false;
} 
if(passwords==="" && hidepawd==="")
{
	this.setState({errormessage:"Please Enter Password.",erropen:true});
	return false;
}

 this.setState({btndisabled:true,submitbtn:"Processing..."})
	 var formData = new FormData();

	  
	 if(this.state.cuid!=="")
	 {
	  
	  formData.append('cu_id',this.state.cuid)
	 }else
	 {
		formData.append('cu_id',0)  
	 }
	 formData.append('action','insertorupdate')
    formData.append('cu_name',names)
	 formData.append('cu_emailid',emailid)
	 formData.append('cu_password',passwords)
		   formData.append('cu_phoneno',phoneno)

	  		
	  formData.append('userid',localStorage.getItem("AYLuserid"))
	  
	 axios.post(Serverurl+"ajaxcustomer.php", formData, {
        }).then(res => {
				if(res.data == -1)
{ 
	 

		this.setState({errormessage:"Customer Already Exist.",erropen:true,open:true,btndisabled:false,
submitbtn:"Submit",
		});
		window.scrollTo({
          top: 0
      })
		 return false;

	}else{
			
					 this.setState({btndisabled:false,
submitbtn:"Submit",logredirect: true, pagename:'/Admincustomer'}); 		  
           
  }
    });    
  };

  render() { 
  
  if (this.state.logredirect === true) {
      return <Navigate to={this.state.pagename} />
    }

  
  return (
 
		<React.Fragment>
	
<div className="boxheading"><h2>Customer Management</h2></div>
<div className="addandbacbtn"><NavLink  to="/Admincustomer" >Back</NavLink></div>
<div className="clear"></div>

  <p>   <Collapse in={this.state.erropen}>
        <Alert
          action={
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={() => {
               this.handleErrorclose();
              }}
            >
              <CloseIcon fontSize="inherit" />
            </IconButton>
          } severity="error"
        >
        {this.state.errormessage}
        </Alert>
      </Collapse></p>
    
 
	
<div className="formmain">

<ul>
  
<li>  
		  <p>Name</p>
		 
		<p>
		<TextField name="names" 
	   onChange={this.myChangeHandler} 
	   fullWidth
	   value={this.state.names}
			 
			  ref={this.usernameInput}
			inputProps={{tabIndex: "1",maxLength:150}} className="txtbox"
	   InputLabelProps={{ shrink: true }}
                          /></p>
 
 </li>
 
  
<li>  <p>Email Id:</p>
		<p> <TextField name="emailid" 
	   onChange={this.myChangeHandler} 
	   fullWidth
	   value={this.state.emailid}
			 
			  ref={this.usernameInput}
			 inputProps={{tabIndex: "2",maxLength:150}} className="txtbox"
	   InputLabelProps={{ shrink: true }}
                          /></p></li>

	  
<li>	  <p > Phone No. : </p>
		  
		  <p > 
		  
		  
		 <TextField name="phoneno" 
	   onChange={this.myChangeHandler} 
	   fullWidth
	   value={this.state.phoneno}
			 
			  ref={this.usernameInput}
			inputProps={{tabIndex: "4",maxLength:10}} className="txtbox" 
	   InputLabelProps={{ shrink: true }}
                          />
		  </p></li>
		  
		<li>	  <p >Password : </p>
		  
		  <p> 
		  <TextField name="passwords" 
	   onChange={this.myChangeHandler} 
	   fullWidth
	   
	   value={this.state.passwords}
			type="password" 
			  ref={this.usernameInput}
			 inputProps={{tabIndex: "3",maxLength:15}} className="txtbox"
	   InputLabelProps={{ shrink: true }}
                          />
		  
		 
		  </p></li>  
	

</ul>
		

</div>
		
          <p className="aligncentr"> 
		  <Button variant="contained" className="frmSecondarybtn" onClick={this.handleSubmit}>
   {this.state.submitbtn}
</Button></p>
		 

 </React.Fragment>
  );
  }
}